export default "__VITE_ASSET__hs4647ZH__"